// src/components/clubs/EditCompetitionPage.js
import React, { useState, useEffect, useRef } from 'react';
// Firebase importok
import { db, auth } from '../../firebase';
import { collection, serverTimestamp, doc, getDoc, updateDoc } from 'firebase/firestore';
import { useParams, useNavigate } from 'react-router-dom';
import { FiCheckCircle, FiPlus, FiMapPin, FiChevronDown, FiMinus } from 'react-icons/fi';
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import GoogleMapPicker from '../GoogleMapPicker';

//KOROSZTÁLY ADATOK
const ageCategoryOptions = [
    { value: '', label: 'Válasszon korosztályt...' },
    { value: 'all', label: 'Összes korosztály' },
    { value: 'mini', label: 'mini', min: 5, max: 9 },
    { value: 'gyerek', label: 'gyerek', min: 10, max: 12 },
    { value: 'junior', label: 'Junior', min: 13, max: 14 },
    { value: 'kadet', label: 'Kadét', min: 15, max: 17 },
    { value: 'ifi', label: 'Ifi', min: 15, max: 18 },
    { value: 'fiatal_felnott', label: 'fiatal felnőtt', min: 18, max: 20 },
    { value: 'felnott', label: 'felnőtt', min: 21, max: 49 },
    { value: 'szenior', label: 'Szenior', min: 50, max: 64 },
    { value: 'veteran', label: 'veterán', min: 65, max: 99 }
];

// KATEGÓRIA ADATOK
const categoryMappings = {
  '3d': [
    { value: '', label: 'Válasszon 3D íjkategóriát...' },
    { isGroupLabel: true, label: 'HDH-IAA' },
    { value: '3d_hdh_bb', label: 'BB (Barebow)' },
    { value: '3d_hdh_bg', label: 'BG (Fúvócső)' },
    { value: '3d_hdh_cb', label: 'CB (Csigás Barebow)' },
    { value: '3d_hdh_crb', label: 'CRB (Számszeríj)' },
    { value: '3d_hdh_cu', label: 'CU (Scope-os Csigás)' },
    { value: '3d_hdh_hu', label: 'HU (Vadász Csigás)' },
    { value: '3d_hdh_ol', label: 'OL (Olimpiai)' },
    { value: '3d_hdh_pbhb', label: 'PBHB (Tradi)' },
    { value: '3d_hdh_trlb', label: 'TRLB (Longbow)' },
    { value: '3d_hdh_trrb', label: 'TRRB (Vadászreflex)' },
    { isGroupLabel: true, label: 'IFAA' },
    { value: '3d_ifaa_bbc', label: 'BB(C) (Barebow-Csigás)' },
    { value: '3d_ifaa_bbr', label: 'BB(R) (Barebow-Reflex)' },
    { value: '3d_ifaa_bhc', label: 'BH(C) (Vadászijász-Csigás)' },
    { value: '3d_ifaa_bhr', label: 'BH(R) (Vadászijász-Reflex)' },
    { value: '3d_ifaa_bl', label: 'BL (Korlátozott Vadászijász)' },
    { value: '3d_ifaa_bu', label: 'BU (Bowhunter Unlimited)' },
    { value: '3d_ifaa_fsc', label: 'FS(C) (Korl. nyílt o.-Csigás)' },
    { value: '3d_ifaa_fsr', label: 'FS(R) (Korl. nyílt o.-Reflex)' },
    { value: '3d_ifaa_fu', label: 'FU (Korlátlan nyílt osztály)' },
    { value: '3d_ifaa_hb', label: 'HB (Történelmi íj)' },
    { value: '3d_ifaa_hbm', label: 'HB(M) (Történelmi íj modern)' },
    { value: '3d_ifaa_lb', label: 'LB (Longbow)' },
    { value: '3d_ifaa_tr', label: 'TR (Tradicionális reflex)' }
  ],
    'terep': [
    { value: '', label: 'Válasszon terep kategóriát...' },
    { value: 'terep_olimpiai', label: 'OL (Olimpiai)' },
    { value: 'terep_csigas', label: 'CU (Scope-os Csigás)' },
    { value: 'terep_barebow', label: 'BB (Barebow)' },
    { value: 'terep_cb', label: 'CB (Csigás Barebow)' },
    { value: 'terep_hu', label: 'HU (Vadász Csigás)' },
    { value: 'terep_pbhb', label: 'PBHB (Tradi - Pusztai íj)' },
    { value: 'terep_trlb', label: 'TRLB (Longbow)' },
    { value: 'terep_trrb', label: 'TRRB (Vadászreflex)' }
  ],
    'palya': [
    { value: '', label: 'Válasszon pálya kategóriát...' },
    { isGroupLabel: true, label: 'WA (World Archery)' },
    { value: 'palya_wa_ol', label: 'R (Olimpiai reflexíj)' },
    { value: 'palya_wa_cu', label: 'CU (Scope-os Csigás)' },
    { value: 'palya_wa_hu', label: 'HU (Vadász Csigás)' },
    { value: 'palya_wa_bb', label: 'B (Barebow)' },
    { value: 'palya_wa_trrb', label: 'TRRB (Vadászreflex)' },
    { value: 'palya_wa_trlb', label: 'TRLB (Longbow)' },
    { value: 'palya_wa_pbhb', label: 'PBHB (Tradi - Pusztai íj)' },
    { value: 'palya_wa_crb', label: 'CRB (Számszeríj)' },
    { isGroupLabel: true, label: 'IFAA' },
    { value: 'palya_ifaa_fu', label: 'FU (Freestyle Unlimited)' },
    { value: 'palya_ifaa_fsr', label: 'FSR (Freestyle Ltd Recurve)' },
    { value: 'palya_ifaa_fsc', label: 'FSC (Freestyle Ltd Compound)' },
    { value: 'palya_ifaa_bbr', label: 'BBR (Barebow Recurve)' },
    { value: 'palya_ifaa_bbc', label: 'BBC (Barebow Compound)' },
    { value: 'palya_ifaa_bu', label: 'BU (Bowhunter Unlimited)' },
    { value: 'palya_ifaa_bl', label: 'BL (Bowhunter Limited)' },
    { value: 'palya_ifaa_bhc', label: 'BHC (Bowhunter Compound)' },
    { value: 'palya_ifaa_bhr', label: 'BHR (Bowhunter Recurve)' },
    { value: 'palya_ifaa_lb', label: 'LB (Longbow)' },
    { value: 'palya_ifaa_hb', label: 'HB (Historical Bow)' },
    { value: 'palya_ifaa_tr', label: 'TR (Traditional Bow)' }
  ],
    'tortenelmi': [
    { value: '', label: 'Válasszon történelmi kategóriát...' },
    { value: 'tortenelmi_pusztai_modern', label: 'Modern pusztai íj' },
    { value: 'tortenelmi_pusztai_termeszetes', label: 'Természetes pusztai íj' },
    { value: 'tortenelmi_botij', label: 'Történelmi hosszúíj / Botíj' },
    { value: 'tortenelmi_vadaszij', label: 'Hagyományos vadászíj' },
    { value: 'tortenelmi_szamszerij', label: 'Történelmi számszeríj' },
    { value: 'tortenelmi_bb', label: 'BB (Barebow - Vendég kategória)' },
  ],
    'oromijasz': [
    { value: '', label: 'Válasszon örömijász kategóriát...' },
    { value: 'orom_wa_ol', label: 'OL (Olimpiai reflexíj)' },
    { value: 'orom_wa_cu', label: 'CU (Scope-os Csigás)' },
    { value: 'orom_wa_hu', label: 'HU (Vadász Csigás)' },
    { value: 'orom_wa_cb', label: 'CB (Csigás Barebow)' },
    { value: 'orom_wa_bb', label: 'BB (Barebow)' },
    { value: 'orom_wa_trrb', label: 'TRRB (Vadászreflex)' },
    { value: 'orom_wa_trlb', label: 'TRLB (Longbow)' },
    { value: 'orom_wa_pbhb', label: 'PBHB (Pusztai íj)' },
    { value: 'orom_wa_crb', label: 'CRB (Számszeríj)' },
    { value: 'orom_wa_bg', label: 'BG (Fúvócső)' }
  ],
  'egyeb': [
    { value: '', label: 'Válasszon egyéb kategóriát...' },
    { value: 'egyeb_wa_ol', label: 'OL (Olimpiai reflexíj)' },
    { value: 'egyeb_wa_cu', label: 'CU (Scope-os Csigás)' },
    { value: 'egyeb_wa_hu', label: 'HU (Vadász Csigás)' },
    { value: 'egyeb_wa_cb', label: 'CB (Csigás Barebow)' },
    { value: 'egyeb_wa_bb', label: 'BB (Barebow)' },
    { value: 'egyeb_wa_trrb', label: 'TRRB (Vadászreflex)' },
    { value: 'egyeb_wa_trlb', label: 'TRLB (Longbow)' },
    { value: 'egyeb_wa_pbhb', label: 'PBHB (Pusztai íj)' },
    { value: 'egyeb_wa_crb', label: 'CRB (Számszeríj)' },
    { value: 'egyeb_wa_bg', label: 'BG (Fúvócső)' },
    { value: 'egyeb_altalanos', label: 'Egyéb Általános' }
  ]
};

// GLOBÁLIS KATEGÓRIA LISTA (IFAA ÉS DUPLIKÁCIÓ NÉLKÜL)
const globalCategoryOptions = [
    { value: '', label: 'Válasszon kategóriát...' },
    { value: '3d_hdh_bb', label: 'BB (Barebow)' },
    { value: '3d_hdh_cu', label: 'CU (Scope-os Csigás)' },
    { value: '3d_hdh_hu', label: 'HU (Vadász Csigás)' },
    { value: '3d_hdh_ol', label: 'OL (Olimpiai)' },
    { value: '3d_hdh_trrb', label: 'TRRB (Vadászreflex)' },
    { value: '3d_hdh_trlb', label: 'TRLB (Longbow)' },
    { value: '3d_hdh_pbhb', label: 'PBHB (Pusztai íj / Tradi)' },
    { value: '3d_hdh_crb', label: 'CRB (Számszeríj)' },
    { value: '3d_hdh_bg', label: 'BG (Fúvócső)' },
    { value: '3d_hdh_cb', label: 'CB (Csigás Barebow)' },
    { value: 'tortenelmi_pusztai_modern', label: 'Modern pusztai íj' },
    { value: 'tortenelmi_pusztai_termeszetes', label: 'Természetes pusztai íj' },
    { value: 'tortenelmi_botij', label: 'Történelmi hosszúíj / Botíj' },
    { value: 'tortenelmi_vadaszij', label: 'Hagyományos vadászíj' },
    { value: 'tortenelmi_szamszerij', label: 'Történelmi számszeríj' }
];

const tieBreakingOptions = [
    { value: '', label: 'Válasszon szabályt...' },
    { value: 'shoot_off', label: 'Szétlövés' },
    { value: 'more_elevens_xs', label: 'Több 11/X' },
    { value: 'more_tens', label: 'Több 10' },
    { value: 'more_eights', label: 'Több 8' },
    { value: 'more_fives', label: 'Több 5' },
    { value: 'fewer_zeros', label: 'Kevesebb 0' }
];

const EditCompetitionPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const locationInputRef = useRef(null);
  const categoryDropdownRef = useRef(null);
  const ageDropdownRef = useRef(null);
  const tieDropdownRef = useRef(null);
  const places = useMapsLibrary('places');

  const scoreButtonStyle = (isSelected) => ({
    width: '42px',
    height: '42px',
    borderRadius: '6px',
    border: isSelected ? '1px solid #b30000' : '1px solid #ccc',
    backgroundColor: isSelected ? '#b30000' : 'white',
    color: isSelected ? 'white' : '#333',
    fontWeight: 'bold',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'all 0.15s ease',
    fontSize: '1rem'
  });

  const competitionTypeOptions = [
    { value: '', label: 'Válasszon típust...' },
    { value: '3d', label: '3D' },
    { value: 'terep', label: 'Terep' },
    { value: 'palya', label: 'Pálya' },
    { value: 'tortenelmi', label: 'Történelmi' },
    { value: 'oromijasz', label: 'Örömijász' },
    { value: 'egyeb', label: 'Egyéb' }
  ];

  const [formData, setFormData] = useState(null);
  const [currentCategoryOptions, setCurrentCategoryOptions] = useState([]);
  const [showAllCategories, setShowAllCategories] = useState(false); // ÚJ STATE
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showCustomScoreModal, setShowCustomScoreModal] = useState(false);
  const [customScoreInput, setCustomScoreInput] = useState('');
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
  const [showAgeDropdown, setShowAgeDropdown] = useState(false);
  const [showTieDropdown, setShowTieDropdown] = useState(false);

  // --- HELYSZÍN AUTOCOMPLETE LOGIKA ---
  useEffect(() => {
    if (!places || !locationInputRef.current) return;

    const options = {
      fields: ['geometry', 'name', 'formatted_address'],
      componentRestrictions: { country: 'hu' }
    };

    const autocomplete = new places.Autocomplete(locationInputRef.current, options);

    autocomplete.addListener('place_changed', () => {
      const place = autocomplete.getPlace();
      if (place && place.geometry && place.geometry.location) {
        const lat = place.geometry.location.lat();
        const lng = place.geometry.location.lng();

        setFormData(prev => ({
          ...prev,
          location: place.formatted_address || place.name,
          gpsLatitude: lat.toFixed(6),
          gpsLongitude: lng.toFixed(6)
        }));
      }
    });

    const style = document.createElement('style');
    style.innerHTML = '.pac-container { z-index: 10000 !important; }';
    document.head.appendChild(style);

    return () => {
      const pacContainers = document.querySelectorAll('.pac-container');
      pacContainers.forEach(container => container.remove());
      document.head.removeChild(style);
    };
  }, [places]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
        setShowCategoryDropdown(false);
      }
      if (ageDropdownRef.current && !ageDropdownRef.current.contains(event.target)) {
        setShowAgeDropdown(false);
      }
      if (tieDropdownRef.current && !tieDropdownRef.current.contains(event.target)) {
        setShowTieDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // --- ADATOK BETÖLTÉSE ---
  useEffect(() => {
    const fetchCompetitionData = async () => {
      if (!id) return;
      try {
        const docRef = doc(db, "events", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();

          // Adatkonverzió: TieBreakingRules (ha még régi string alapú)
          let currentTieRules = [];
          if (Array.isArray(data.tieBreakingRules)) {
            currentTieRules = data.tieBreakingRules;
          } else if (data.tieBreakingRule) {
            currentTieRules = [data.tieBreakingRule];
          }

          setFormData({
            ...data,
            tieBreakingRules: currentTieRules,
            ageFees: data.ageFees || {},
            ageLimits: data.ageLimits || {},
            scoringValues: data.scoringValues || []
          });

          if (data.competitionType && categoryMappings[data.competitionType]) {
            setCurrentCategoryOptions(categoryMappings[data.competitionType]);
          }
        } else {
          alert("A verseny nem található!");
          navigate('/egyesulet-dashboard');
        }
      } catch (error) {
        console.error("Hiba a betöltéskor:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCompetitionData();
  }, [id, navigate]);

  // ÚJ: Kategória opciók váltása a kapcsoló alapján
  useEffect(() => {
    if (showAllCategories) {
      setCurrentCategoryOptions(globalCategoryOptions);
    } else if (formData?.competitionType && categoryMappings[formData.competitionType]) {
      setCurrentCategoryOptions(categoryMappings[formData.competitionType]);
    } else {
      setCurrentCategoryOptions([]);
    }
  }, [showAllCategories, formData?.competitionType]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData(prevFormData => {
      const newFormData = { ...prevFormData };

      if (name === "competitionType") {
        newFormData.competitionType = value;
        newFormData.categories = [];

        if (value && categoryMappings[value]) {
          setCurrentCategoryOptions(categoryMappings[value]);
        } else {
          setCurrentCategoryOptions([]);
        }
      } else if (type === 'checkbox') {
        newFormData[name] = checked;
      } else {
        newFormData[name] = value;
      }
      return newFormData;
    });
  };

  const toggleTieBreakingRule = (val) => {
    setFormData(prev => {
        const current = prev.tieBreakingRules;
        const next = current.includes(val)
            ? current.filter(v => v !== val)
            : [...current, val];

        return { ...prev, tieBreakingRules: next };
    });
  };

  const handleRemoveCategory = (categoryValueToRemove) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      categories: prevFormData.categories.filter(catVal => catVal !== categoryValueToRemove)
    }));
  };

  const toggleCategory = (val) => {
    setFormData(prev => {
      const current = prev.categories;
      const next = current.includes(val)
        ? current.filter(v => v !== val)
        : [...current, val];
      return { ...prev, categories: next };
    });
  };

  const handleAgeSelectionChange = (event) => {
    const selectedValue = event.target.value;

    if (selectedValue === 'all') {
        const allAges = ageCategoryOptions
            .filter(opt => opt.value !== '' && opt.value !== 'all');

        const allAgeValues = allAges.map(opt => opt.value);
        const allAgeLimits = {};
        allAges.forEach(opt => {
            allAgeLimits[opt.value] = { min: opt.min, max: opt.max };
        });

        setFormData(prevFormData => ({
            ...prevFormData,
            ageCategories: allAgeValues,
            ageLimits: { ...prevFormData.ageLimits, ...allAgeLimits }
        }));
    } else if (selectedValue && selectedValue !== '') {
        toggleAge(selectedValue);
    }
  };

  const toggleAge = (val) => {
    setFormData(prev => {
        const current = prev.ageCategories;
        const next = current.includes(val)
            ? current.filter(v => v !== val)
            : [...current, val];

        const newAgeFees = { ...prev.ageFees };
        const newAgeLimits = { ...prev.ageLimits };

        if (current.includes(val)) {
            delete newAgeFees[val];
            delete newAgeLimits[val];
        } else {
            const opt = ageCategoryOptions.find(o => o.value === val);
            if (opt) {
                newAgeLimits[val] = { min: opt.min, max: opt.max };
            }
        }

        return { ...prev, ageCategories: next, ageFees: newAgeFees, ageLimits: newAgeLimits };
    });
  };

  const handleAgeLimitChange = (ageVal, type, value) => {
    const numValue = value === '' ? '' : parseInt(value);
    setFormData(prev => ({
        ...prev,
        ageLimits: {
            ...prev.ageLimits,
            [ageVal]: {
                ...prev.ageLimits[ageVal],
                [type]: numValue
            }
        }
    }));
  };

  const toggleScoringValue = (val) => {
    setFormData(prev => {
      const current = prev.scoringValues;
      const next = current.includes(val)
        ? current.filter(v => v !== val)
        : [...current, val].sort((a, b) => {
            if (a === 'X') return 1;
            if (b === 'X') return -1;
            return parseInt(a) - parseInt(b);
          });
      return { ...prev, scoringValues: next };
    });
  };

  const handleAddCustomScore = () => {
    if (customScoreInput.trim() !== '') {
      toggleScoringValue(customScoreInput.trim());
      setCustomScoreInput('');
      setShowCustomScoreModal(false);
    }
  };

const handleRemoveAgeCategory = (valueToRemove) => {
    setFormData(prevFormData => {
        const newAgeFees = { ...prevFormData.ageFees };
        delete newAgeFees[valueToRemove];

        return {
            ...prevFormData,
            ageCategories: prevFormData.ageCategories.filter(val => val !== valueToRemove),
            ageFees: newAgeFees
        };
    });
};

const handleRemoveTieRule = (valToRemove) => {
    setFormData(prev => ({
        ...prev,
        tieBreakingRules: prev.tieBreakingRules.filter(v => v !== valToRemove)
    }));
};

const handleAgeFeeChange = (ageVal, fee) => {
    if (fee === '' || /^[0-9\b]+$/.test(fee)) {
        setFormData(prev => ({
            ...prev,
            ageFees: {
                ...prev.ageFees,
                [ageVal]: fee
            }
        }));
    }
};

  const handleNumericChange = (e) => {
    const { name, value } = e.target;
    if (value === '' || /^[0-9\b]+$/.test(value)) {
      setFormData(prevState => ({ ...prevState, [name]: value }));
    }
  };

    const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!formData.competitionType) {
        alert('Kérjük, válassza ki a verseny típusát!');
        setIsSubmitting(false);
        return;
    }
    const hasActualSelectableCategories = currentCategoryOptions &&
                                          currentCategoryOptions.some(cat => cat.value !== '' && !cat.isGroupLabel);
    if (hasActualSelectableCategories && formData.categories.length === 0) {
        alert('Kérjük, válasszon ki legalább egy íjkategóriát!');
        setIsSubmitting(false);
        return;
    }

    if (formData.ageCategories.length === 0) {
        alert('Kérjük, válasszon ki legalább egy korosztályt!');
        setIsSubmitting(false);
        return;
    }

    if (formData.scoringValues.length === 0) {
        alert('Kérjük, adjon meg legalább egy találati értéket!');
        setIsSubmitting(false);
        return;
    }
    if (formData.tieBreakingRules.length === 0) {
        alert('Kérjük, válasszon legalább egy pontegyenlőségi szabályt!');
        setIsSubmitting(false);
        return;
    }

    const currentUser = auth.currentUser;
    if (!currentUser) {
        alert('A mentéshez be kell jelentkeznie!');
        setIsSubmitting(false);
        return;
    }

    // --- ÚJ: Klub logó lekérése mentés előtt a kártyákhoz ---
    let logoUrl = '';
    try {
        const clubRef = doc(db, "Clubs", currentUser.uid);
        const clubSnap = await getDoc(clubRef);
        if (clubSnap.exists()) {
            logoUrl = clubSnap.data().logoUrl || '';
        }
    } catch (e) {
        console.error("Hiba a logó lekérésekor:", e);
    }

    const dataToSend = {
        ...formData,
        organizingClubLogoUrl: logoUrl, // ÚJ MEZŐ A KÁRTYÁKHOZ
        updatedAt: serverTimestamp(),
        scoringValues: formData.scoringValues,
        categories: formData.categories,
        ageCategories: formData.ageCategories,
        effectiveTieBreakingRule: formData.tieBreakingRules.join(', '),
    };

    try {
        const docRef = doc(db, "events", id);
        await updateDoc(docRef, dataToSend);
        setShowSuccessModal(true);
    } catch (error) {
        console.error("Hiba történt az esemény mentése közben: ", error);
        alert(`Hiba történt az esemény mentése közben: ${error.message}`);
    } finally {
        setIsSubmitting(false);
    }
};

  // --- STÍLUSOK (A CreateCompetitionPage-ből) ---
  const pageStyle = { padding: '2rem 1rem', fontFamily: 'Arial, sans-serif', margin: '2rem 0', backgroundColor: '#f0f2f5', minHeight: 'calc(100vh - 4rem)' };
  const cardStyle = { backgroundColor: '#ffffff', padding: '2rem', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)', width: '100%', boxSizing: 'border-box' };
  const leftColumnStyle = { flex: 1, display: 'flex', flexDirection: 'column' };
  const rightColumnStyle = { flex: 1, display: 'flex', flexDirection: 'column' };
  const headingStyle = { color: '#b30000', textAlign: 'center', marginBottom: '2rem' };
  const labelStyle = { fontWeight: 'bold', marginBottom: '0.3rem', display: 'block' };
  const inputStyle = { padding: '0.7rem', borderRadius: '4px', border: '1px solid #ccc', width: '100%', boxSizing: 'border-box', backgroundColor: 'white' };
  const checkboxLabelStyle = { display: 'flex', alignItems: 'center', gap: '0.5rem', fontWeight: 'normal', cursor: 'pointer' };
  const radioGroupStyle = { display: 'flex', gap: '1rem', alignItems: 'center', flexWrap: 'wrap', marginBottom: '1rem' };
  const formSectionGroupStyle = { display: 'flex', flexDirection: 'column', gap: '1.2rem' };
  const sectionTitleStyle = { fontSize: '1.3rem', color: '#333', borderBottom: '1px solid #ddd', paddingBottom: '0.5rem', marginBottom: '1rem' };
  const descriptionTextAreaStyle = { ...inputStyle, minHeight: 'calc(100% - 3rem)', height: 'auto', resize: 'vertical', flexGrow: 1 };
  const submitButtonStyle = { ...inputStyle, backgroundColor: '#b30000', color: 'white', fontWeight: 'bold', cursor: 'pointer', marginTop: '1.5rem' };
  const modalOverlayStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000,
    backdropFilter: 'blur(3px)'
  };
  const formRowStyle = { display: 'flex', alignItems: 'center', gap: '1.5rem', marginBottom: '1rem' };
  const inlineLabelStyle = { fontWeight: 'bold', minWidth: '200px', marginBottom: 0 };
  const modalContentStyle = { backgroundColor: 'white', padding: '30px', borderRadius: '16px', textAlign: 'center', maxWidth: '400px', width: '90%', boxShadow: '0 20px 40px rgba(0,0,0,0.3)' };
  const modalOkButtonStyle = { backgroundColor: '#b30000', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' };
  const modalCancelButtonStyle = { backgroundColor: '#eee', color: '#333', border: 'none', padding: '12px 24px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' };
  const highlightedCheckboxStyle = { display: 'flex', alignItems: 'center', gap: '0.5rem', backgroundColor: '#fff9c4', padding: '0.4rem 0.8rem', borderRadius: '6px', border: '1px solid #fbc02d', fontSize: '0.85rem', fontWeight: 'bold', color: '#5f4b00', cursor: 'pointer', transition: '0.2s' };
  const dropdownListStyle = { position: 'absolute', top: '100%', left: 0, right: 0, backgroundColor: 'white', border: '1px solid #ccc', borderRadius: '4px', boxShadow: '0 4px 12px rgba(0,0,0,0.15)', zIndex: 1000, maxHeight: '300px', overflowY: 'auto', marginTop: '2px', padding: '8px 0' };
  const dropdownItemStyle = { padding: '8px 12px', display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', transition: 'background 0.2s', fontSize: '0.9rem' };
  const dropdownGroupLabelStyle = { padding: '8px 12px 4px 12px', fontSize: '0.75rem', fontWeight: 'bold', color: '#b30000', textTransform: 'uppercase', letterSpacing: '0.05em', borderTop: '1px solid #eee', marginTop: '4px' };
  const customSelectButtonStyle = { ...inputStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer', userSelect: 'none' };

  if (loading) return <div style={pageStyle}><h2 style={headingStyle}>Betöltés...</h2></div>;
  if (!formData) return null;

  return (
    <div style={pageStyle}>
      {showSuccessModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <FiCheckCircle size={50} color="#28a745" style={{ marginBottom: '15px' }} />
            <h3 style={{ margin: '0 0 10px 0', color: '#333' }}>Sikeres mentés!</h3>
            <p style={{ color: '#666', marginBottom: '25px' }}>
              A verseny módosítása sikeresen megtörtént.
            </p>
            <button
              style={modalOkButtonStyle}
               onClick={() => {
                setShowSuccessModal(false);
                navigate('/egyesulet-dashboard');
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      {showCustomScoreModal && (
        <div style={modalOverlayStyle}>
          <div style={modalContentStyle}>
            <h3 style={{ margin: '0 0 15px 0' }}>Egyedi pontszám</h3>
            <p style={{ color: '#666', marginBottom: '15px' }}>Írd be a pontszámot (pl. 24):</p>
            <input
              type="text"
              value={customScoreInput}
              onChange={(e) => setCustomScoreInput(e.target.value)}
              style={{ ...inputStyle, textAlign: 'center', fontSize: '1.5rem', marginBottom: '20px' }}
              autoFocus
            />
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center' }}>
              <button style={modalCancelButtonStyle} onClick={() => setShowCustomScoreModal(false)}>Mégse</button>
              <button style={modalOkButtonStyle} onClick={handleAddCustomScore}>Hozzáadás</button>
            </div>
          </div>
        </div>
      )}

      <h1 style={headingStyle}>Verseny Szerkesztése</h1>

      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '2rem' }}>

        <div style={{ display: 'flex', flexDirection: 'row', gap: '2rem' }}>

          <div style={leftColumnStyle}>
            <div style={cardStyle}>
              <div style={formSectionGroupStyle}>
                <div style={sectionTitleStyle}>Általános Beállítások</div>
                <div>
                  <label style={labelStyle}>Létrehozás típusa:</label>
                  <div style={radioGroupStyle}>
                    <label style={checkboxLabelStyle}>
                      <input type="radio" name="creationType" value="full_event" checked={formData.creationType === 'full_event'} onChange={handleChange} />
                      Nevezéssel együtt
                    </label>
                    <label style={checkboxLabelStyle}>
                      <input type="radio" name="creationType" value="announcement" checked={formData.creationType === 'announcement'} onChange={handleChange} />
                      Csak kiírás (nevezés nélkül)
                    </label>
                  </div>
                </div>
                <div>
                  <label style={labelStyle}>Formátum:</label>
                  <div style={radioGroupStyle}>
                    <label style={checkboxLabelStyle}>
                      <input type="radio" name="format" value="normal" checked={formData.format === 'normal'} onChange={handleChange} />
                      Normál
                    </label>
                    <label style={checkboxLabelStyle}>
                      <input type="radio" name="format" value="multi_day_distance" checked={formData.format === 'multi_day_distance'} onChange={handleChange} />
                      Több nap/táv
                    </label>
                  </div>
                </div>

                <div style={{ ...formRowStyle, alignItems: 'flex-start' }}>
                  <label htmlFor="competitionName" style={{ ...inlineLabelStyle, marginTop: '10px' }}>Verseny neve:</label>
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '8px' }}>
                    <input type="text" id="competitionName" name="competitionName" value={formData.competitionName} onChange={handleChange} style={inputStyle} required />
                    <label style={highlightedCheckboxStyle}>
                      <input type="checkbox" name="isInternational" checked={formData.isInternational} onChange={handleChange} />
                      Nemzetközi verseny
                    </label>
                  </div>
                </div>

                <div style={formRowStyle}>
                  <label htmlFor="competitionType" style={inlineLabelStyle}>Verseny típusa:</label>
                  <div style={{ flex: 1 }}>
                    <select id="competitionType" name="competitionType" value={formData.competitionType} onChange={handleChange} style={inputStyle} required >
                      {competitionTypeOptions.map(option => (
                        <option key={option.value} value={option.value} disabled={option.value === ''}>{option.label}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div style={formRowStyle}>
                  <div style={{ ...inlineLabelStyle, display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    <label>Íjkategória hozzáadása:</label>
                    <label style={{ ...highlightedCheckboxStyle, fontSize: '0.75rem', padding: '0.4rem 0.8rem', width: '100%', boxSizing: 'border-box' }}>
                      <input
                        type="checkbox"
                        checked={showAllCategories}
                        onChange={(e) => setShowAllCategories(e.target.checked)}
                      />
                      Összes kategória
                    </label>
                  </div>
                  <div style={{ flex: 1, position: 'relative' }} ref={categoryDropdownRef}>
                    <div
                      style={customSelectButtonStyle}
                      onClick={() => {
                        if (showAllCategories || (formData.competitionType && currentCategoryOptions.length > 0)) {
                          setShowCategoryDropdown(!showCategoryDropdown);
                        }
                      }}
                    >
                      <span style={{ color: formData.categories.length > 0 ? '#333' : '#777' }}>
                        {formData.categories.length > 0
                          ? `${formData.categories.length} kategória kiválasztva`
                          : (showAllCategories ? 'Válassz kategóriákat...' : (!formData.competitionType ? 'Először válasszon verseny típust!' : 'Válassz kategóriákat...'))}
                      </span>
                      <FiChevronDown style={{ transform: showCategoryDropdown ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
                    </div>

                    {showCategoryDropdown && (
                      <div style={dropdownListStyle}>
                        {currentCategoryOptions.map((item, idx) => {
                          if (item.value === '') return null;
                          if (item.isGroupLabel) {
                            return <div key={`group-${idx}`} style={dropdownGroupLabelStyle}>{item.label}</div>;
                          }
                          const isSelected = formData.categories.includes(item.value);
                          return (
                            <div
                              key={item.value}
                              style={{ ...dropdownItemStyle, backgroundColor: isSelected ? '#fff5f5' : 'transparent' }}
                              onClick={() => toggleCategory(item.value)}
                            >
                              <input type="checkbox" checked={isSelected} readOnly style={{ cursor: 'pointer' }} />
                              <span style={{ fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? '#b30000' : '#333' }}>
                                {item.label}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>

                {formData.categories.length > 0 && (
                  <div style={{ marginTop: '0.5rem', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '4px', background: '#f8f9fa', marginLeft: '200px' }}>
                    <h5 style={{ marginTop: '0', marginBottom: '0.5rem', fontSize: '0.95em' }}>Kiválasztott íjkategóriák:</h5>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
                      {formData.categories.map(categoryValue => {
                        const allOptions = Object.values(categoryMappings).flat();
                        const label = allOptions.find(opt => opt.value === categoryValue)?.label || categoryValue;

                        return (
                          <span key={categoryValue} style={{ background: '#e9ecef', padding: '2px 8px', borderRadius: '10px', fontSize: '0.85em', display: 'flex', alignItems: 'center', border: '1px solid #dee2e6' }}>
                            {label}
                            <button type="button" onClick={() => handleRemoveCategory(categoryValue)} style={{ marginLeft: '5px', border: 'none', color: '#dc3545', background: 'none', cursor: 'pointer', fontWeight: 'bold' }}>×</button>
                          </span>
                        );
                      })}
                    </div>
                  </div>
                )}

                <div style={formRowStyle}>
                  <label style={inlineLabelStyle}>Korosztály hozzáadása:</label>
                  <div style={{ flex: 1, position: 'relative' }} ref={ageDropdownRef}>
                    <div
                      style={customSelectButtonStyle}
                      onClick={() => setShowAgeDropdown(!showAgeDropdown)}
                    >
                      <span style={{ color: formData.ageCategories.length > 0 ? '#333' : '#777' }}>
                        {formData.ageCategories.length > 0
                          ? `${formData.ageCategories.length} korosztály kiválasztva`
                          : 'Válassz korosztályokat...'}
                      </span>
                      <FiChevronDown style={{ transform: showAgeDropdown ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
                    </div>

                    {showAgeDropdown && (
                      <div style={dropdownListStyle}>
                        {ageCategoryOptions.map((opt) => {
                          if (opt.value === '') return null;
                          if (opt.value === 'all') {
                            return (
                              <div
                                key="all"
                                style={{ ...dropdownItemStyle, borderBottom: '1px solid #eee', fontWeight: 'bold' }}
                                onClick={() => handleAgeSelectionChange({ target: { value: 'all' } })}
                              >
                                <span>{opt.label}</span>
                              </div>
                            );
                          }
                          const isSelected = formData.ageCategories.includes(opt.value);
                          return (
                            <div
                              key={opt.value}
                              style={{ ...dropdownItemStyle, backgroundColor: isSelected ? '#fff5f5' : 'transparent' }}
                              onClick={() => toggleAge(opt.value)}
                            >
                              <input type="checkbox" checked={isSelected} readOnly style={{ cursor: 'pointer' }} />
                              <span style={{ fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? '#b30000' : '#333' }}>
                                {opt.label}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>

                {formData.ageCategories.length > 0 && (
                  <div style={{ marginTop: '0.5rem', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '4px', background: '#f8f9fa', marginLeft: '200px' }}>
                    <h5 style={{ marginTop: '0', marginBottom: '0.8rem', fontSize: '0.95em' }}>Kiválasztott korosztályok, korhatárok és nevezésidijak:</h5>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                      {formData.ageCategories.map(ageVal => {
                        const label = ageCategoryOptions.find(o => o.value === ageVal)?.label;
                        return (
                          <div key={ageVal} style={{ display: 'flex', alignItems: 'center', gap: '15px', background: '#fff', padding: '8px 12px', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                            <span style={{ fontWeight: 'bold', fontSize: '0.9em', minWidth: '90px' }}>{label}</span>

                            {/* Korhatár évek */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                              <input
                                type="number"
                                value={formData.ageLimits[ageVal]?.min ?? ''}
                                onChange={(e) => handleAgeLimitChange(ageVal, 'min', e.target.value)}
                                style={{ width: '45px', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85em', textAlign: 'center' }}
                              />
                              <span style={{ fontSize: '0.8em', color: '#888' }}>-</span>
                              <input
                                type="number"
                                value={formData.ageLimits[ageVal]?.max ?? ''}
                                onChange={(e) => handleAgeLimitChange(ageVal, 'max', e.target.value)}
                                style={{ width: '45px', padding: '5px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85em', textAlign: 'center' }}
                              />
                              <span style={{ fontSize: '0.8em', color: '#888' }}>év</span>
                            </div>

                            {/* Nevezési díj */}
                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px', marginLeft: '10px' }}>
                              <div style={{ position: 'relative', width: '100px' }}>
                                <input
                                  type="text"
                                  value={formData.ageFees[ageVal] || ''}
                                  onChange={(e) => handleAgeFeeChange(ageVal, e.target.value)}
                                  style={{ width: '100%', padding: '5px 25px 5px 8px', borderRadius: '4px', border: '1px solid #ccc', fontSize: '0.85em', boxSizing: 'border-box' }}
                                  placeholder="Nev.díj"
                                />
                                <span style={{ position: 'absolute', right: '5px', top: '50%', transform: 'translateY(-50%)', fontSize: '0.75rem', color: '#888', fontWeight: 'bold' }}>Ft</span>
                              </div>
                            </div>

                            <button
                              type="button"
                              onClick={() => handleRemoveAgeCategory(ageVal)}
                              style={{ marginLeft: 'auto', border: 'none', color: '#dc3545', background: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: '1.1em', padding: '0 5px' }}
                            >
                              ×
                            </button>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>

              <div style={formSectionGroupStyle}>
                <div style={sectionTitleStyle}>Dátumok</div>
                {formData.format === 'normal' && (
                  <div style={formRowStyle}>
                    <label htmlFor="competitionDate" style={inlineLabelStyle}>Verseny napja:</label>
                    <div style={{ flex: 1 }}><input type="date" id="competitionDate" name="competitionDate" value={formData.competitionDate} onChange={handleChange} style={inputStyle} /></div>
                  </div>
                )}
                {formData.format === 'multi_day_distance' && (
                    <>
                    <div style={formRowStyle}>
                        <label htmlFor="startDate" style={inlineLabelStyle}>Kezdő dátum:</label>
                        <div style={{ flex: 1 }}>
                          <input type="date" id="startDate" name="startDate" value={formData.startDate} onChange={handleChange} style={inputStyle} />
                        </div>
                    </div>
                    <div style={formRowStyle}>
                        <label htmlFor="endDate" style={inlineLabelStyle}>Befejezés dátuma:</label>
                        <div style={{ flex: 1 }}>
                          <input type="date" id="endDate" name="endDate" value={formData.endDate} onChange={handleChange} style={inputStyle} />
                        </div>
                    </div>
                    </>
                )}
                <div style={formRowStyle}>
                  <label htmlFor="registrationDeadline" style={inlineLabelStyle}>Nevezési határidő:</label>
                  <div style={{ flex: 1 }}><input type="datetime-local" id="registrationDeadline" name="registrationDeadline" value={formData.registrationDeadline} onChange={handleChange} style={inputStyle} /></div>
                </div>
              </div>
            </div>
          </div>

          <div style={rightColumnStyle}>
            <div style={{ ...cardStyle, display: 'flex', flexDirection: 'column', height: '100%' }}>
              <label htmlFor="competitionDescription" style={labelStyle}>Verseny Leírása:</label>
              <textarea
                id="competitionDescription"
                name="competitionDescription"
                value={formData.competitionDescription}
                onChange={handleChange}
                style={{ ...descriptionTextAreaStyle, flex: 1, minHeight: '0' }}
                placeholder="Írd ide a verseny részletes leírását..."
              />
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row', gap: '2rem' }}>

          <div style={leftColumnStyle}>
            <div style={cardStyle}>
              <div style={formSectionGroupStyle}>
                <div style={sectionTitleStyle}>Helyszín és Szervező</div>
                <div style={formRowStyle}>
                  <label htmlFor="location" style={{ ...inlineLabelStyle }}>Helyszín (pontos cím):</label>
                  <div style={{ flex: 1 }}>
                    <input
                      ref={locationInputRef}
                      type="text"
                      id="location"
                      name="location"
                      value={formData.location}
                      onChange={handleChange}
                      style={inputStyle}
                      placeholder="Kezdd el gépelni a címet..."
                    />
                  </div>
                </div>
                <div style={formRowStyle}>
                  <label style={inlineLabelStyle}>GPS pozíció:</label>
                  <div style={{ display: 'flex', gap: '1rem', flex: 1 }}>
                    <input type="text" name="gpsLatitude" placeholder="Szélesség" value={formData.gpsLatitude} onChange={handleChange} style={{ ...inputStyle, width: '50%' }} />
                    <input type="text" name="gpsLongitude" placeholder="Hosszúság" value={formData.gpsLongitude} onChange={handleChange} style={{ ...inputStyle, width: '50%' }} />
                  </div>
                </div>
                <div style={formRowStyle}>
                  <label htmlFor="organizingClub" style={inlineLabelStyle}>Szervező egyesület:</label>
                  <div style={{ flex: 1 }}><input type="text" id="organizingClub" name="organizingClub" value={formData.organizingClub} onChange={handleChange} style={inputStyle} /></div>
                </div>
                <div style={formRowStyle}>
                    <div style={{ minWidth: '200px' }}></div>
                    <label style={{ ...checkboxLabelStyle, flex: 1 }}>
                        <input type="checkbox" name="inMISZCalendar" checked={formData.inMISZCalendar} onChange={handleChange} />
                        MISZ Naptárban szerepel
                    </label>
                </div>
              </div>

              <div style={formSectionGroupStyle}>
                <div style={{ ...formRowStyle, borderBottom: '1px solid #ddd', paddingBottom: '0.5rem', marginBottom: '1.2rem' }}>
                    <div style={{ fontSize: '1.3rem', color: '#333', minWidth: '200px' }}>Étkezés</div>
                    <label style={{ ...checkboxLabelStyle, flex: 1 }}>
                        <input type="checkbox" name="lunchAvailable" checked={formData.lunchAvailable} onChange={handleChange} />
                        Ebéd igényelhető
                    </label>
                </div>

                {formData.lunchAvailable && (
                <div style={{ paddingLeft: '200px', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                    <div style={formRowStyle}>
                        <label style={{ ...checkboxLabelStyle, flex: 1 }}>
                            <input type="checkbox" name="lunchInEntryFee" checked={formData.lunchInEntryFee} onChange={handleChange} />
                            Ebéd ára a nevezési díjban van
                        </label>
                    </div>

                    {!formData.lunchInEntryFee && (
                    <div style={formRowStyle}>
                        <label htmlFor="lunchPrice" style={{ fontWeight: 'bold', marginRight: '1rem' }}>Ebéd ára (Ft):</label>
                        <input
                            type="text"
                            id="lunchPrice"
                            name="lunchPrice"
                            value={formData.lunchPrice}
                            onChange={handleNumericChange}
                            style={{ ...inputStyle, width: '150px' }}
                            placeholder="pl. 2500"
                        />
                    </div>
                    )}
                </div>
                )}
              </div>

              <div style={formSectionGroupStyle}>
                <div style={sectionTitleStyle}>Verseny Technikai Részletei</div>
                <div style={formRowStyle}>
                  <label htmlFor="maxParticipants" style={inlineLabelStyle}>Max. résztvevők száma:</label>
                  <div style={{ flex: 1 }}><input type="text" id="maxParticipants" name="maxParticipants" value={formData.maxParticipants} onChange={handleNumericChange} style={inputStyle} /></div>
                </div>
                <div style={formRowStyle}>
                    <label htmlFor="numberOfTeams" style={inlineLabelStyle}>Csapatok max. száma:</label>
                    <div style={{ flex: 1 }}>
                        <input type="text" id="numberOfTeams" name="numberOfTeams" value={formData.numberOfTeams} onChange={handleChange} style={inputStyle} />
                    </div>
                </div>
                <div style={formRowStyle}>
                    <label htmlFor="numberOfTargets" style={inlineLabelStyle}>Célok száma:</label>
                    <div style={{ flex: 1 }}>
                        <input type="text" id="numberOfTargets" name="numberOfTargets" value={formData.numberOfTargets} onChange={handleChange} style={inputStyle} />
                    </div>
                </div>
                <div style={formRowStyle}>
                    <label htmlFor="shotsPerTarget" style={inlineLabelStyle}>Célonkénti lövések:</label>
                    <div style={{ flex: 1 }}>
                        <input type="text" id="shotsPerTarget" name="shotsPerTarget" value={formData.shotsPerTarget} onChange={handleChange} style={inputStyle} />
                    </div>
                </div>

                <div style={formRowStyle}>
                  <div style={{ minWidth: '200px' }}></div>
                  <label style={{ ...checkboxLabelStyle, flex: 1, color: '#b30000', fontWeight: 'bold' }}>
                    <input type="checkbox" name="crossbowSingleShot" checked={formData.crossbowSingleShot} onChange={handleChange} />
                    Számszeríj csak egy lövés
                  </label>
                </div>

                <div>
                  <label style={labelStyle}>Találati értékek kiválasztása:</label>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', padding: '12px', background: '#f8f9fa', borderRadius: '8px', border: '1px solid #ddd' }}>
                    {['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', 'X'].map(val => (
                      <button key={val} type="button" onClick={() => toggleScoringValue(val)} style={scoreButtonStyle(formData.scoringValues.includes(val))}>{val}</button>
                    ))}
                    <button type="button" onClick={() => setShowCustomScoreModal(true)} style={{ ...scoreButtonStyle(false), backgroundColor: '#eee', color: '#b30000' }}><FiPlus size={20} /></button>
                  </div>
                </div>

                <div style={formRowStyle}>
                    <label style={inlineLabelStyle}>Pontegyenlőség esetén:</label>
                    <div style={{ flex: 1, position: 'relative' }} ref={tieDropdownRef}>
                        <div
                            style={customSelectButtonStyle}
                            onClick={() => setShowTieDropdown(!showTieDropdown)}
                        >
                            <span style={{ color: formData.tieBreakingRules.length > 0 ? '#333' : '#777' }}>
                                {formData.tieBreakingRules.length > 0
                                    ? `${formData.tieBreakingRules.length} szabály kiválasztva`
                                    : 'Válassz szabályokat...'}
                            </span>
                            <FiChevronDown style={{ transform: showTieDropdown ? 'rotate(180deg)' : 'none', transition: '0.2s' }} />
                        </div>

                        {showTieDropdown && (
                            <div style={dropdownListStyle}>
                                {tieBreakingOptions.map((opt) => {
                                    if (opt.value === '') return null;
                                    const isSelected = formData.tieBreakingRules.includes(opt.value);
                                    return (
                                        <div
                                            key={opt.value}
                                            style={{ ...dropdownItemStyle, backgroundColor: isSelected ? '#fff5f5' : 'transparent' }}
                                            onClick={() => toggleTieBreakingRule(opt.value)}
                                        >
                                            <input type="checkbox" checked={isSelected} readOnly style={{ cursor: 'pointer' }} />
                                            <span style={{ fontWeight: isSelected ? 'bold' : 'normal', color: isSelected ? '#b30000' : '#333' }}>
                                                {opt.label}
                                            </span>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                </div>

                {formData.tieBreakingRules.length > 0 && (
                    <div style={{ marginTop: '0.5rem', padding: '0.5rem', border: '1px solid #ddd', borderRadius: '4px', background: '#f8f9fa', marginLeft: '200px' }}>
                        <h5 style={{ marginTop: '0', marginBottom: '0.8rem', fontSize: '0.95em' }}>Kiválasztott szabályok (prioritási sorrendben):</h5>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            {formData.tieBreakingRules.map((ruleVal, index) => (
                                <div key={ruleVal} style={{ display: 'flex', alignItems: 'center', gap: '10px', background: '#fff', padding: '6px 12px', borderRadius: '8px', border: '1px solid #dee2e6' }}>
                                    <span style={{ fontWeight: 'bold', fontSize: '0.9em', color: '#b30000', minWidth: '25px' }}>{index + 1}.</span>
                                    <span style={{ fontSize: '0.9em', color: '#333', flex: 1 }}>
                                        {tieBreakingOptions.find(o => o.value === ruleVal)?.label}
                                    </span>
                                    <button
                                        type="button"
                                        onClick={() => handleRemoveTieRule(ruleVal)}
                                        style={{ border: 'none', color: '#dc3545', background: 'none', cursor: 'pointer', fontWeight: 'bold', fontSize: '1.1em' }}
                                    >
                                        ×
                                    </button>
                                </div>
                            ))}
                        </div>
                    </div>
                )}

              </div>

              <button type="submit" style={submitButtonStyle} disabled={isSubmitting}>
                {isSubmitting ? 'Mentés folyamatban...' : 'Módosítások mentése'}
              </button>
            </div>
          </div>

          <div style={rightColumnStyle}>
            <div style={{
              ...cardStyle,
              height: '550px',
              display: 'flex',
              flexDirection: 'column',
              padding: '10px'
            }}>
              <GoogleMapPicker
                lat={formData.gpsLatitude}
                lng={formData.gpsLongitude}
                onLocationChange={(lat, lng) => {
                  setFormData(prev => ({ ...prev, gpsLatitude: lat, gpsLongitude: lng }));
                }}
              />
              <p style={{ fontSize: '0.8rem', color: '#888', textAlign: 'center', marginTop: '5px' }}>
                Húzd a jelölőt a pontos helyszínre!
              </p>
            </div>
          </div>
        </div>

      </form>
    </div>
  );
};

export default EditCompetitionPage;

